import { termosStep } from '../../shared/termosSections';
import { identificacaoSociedadeSection, enderecoSociedadeStep, DADOS_REQUERIMENTO_ENDERECO_SOCIEDADE } from '../../shared/sociedadeSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';

const VALOR_BASE = 248.00;
const VALOR_POR_AVERBACAO = 75.00;

const pedidoAlteracaoContratualConfig = {
  id: 'pedido_alteracao_contratual',
  nome: 'Pedido de Alteração Contratual',
  descricao: 'Solicitação de alteração contratual de sociedade de advogados',
  icon: 'FaFileContract',
  categoria: 'sociedades',

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento preenchido e assinado digitalmente', required: true },
      { id: 'contratoAlterado', tipoDocumentoProcesso: 411, name: 'Contrato Alterado', description: 'Contrato social com a alteração já consolidada', required: true },
      { id: 'copiaDocumentosSocios', tipoDocumentoProcesso: 459, name: 'Cópia dos Documentos de Identidade dos Sócios', description: 'Cópia dos documentos de identidade de todos os sócios', required: true }
    ],

    conditional: [
      {
        id: 'dbe', tipoDocumentoProcesso: 375,
        name: 'DBE - Documento Básico de Entrada',
        description: 'Documento Básico de Entrada, gerado no site da Redesim. Obrigatório quando a alteração contratual envolver endereço, quadro societário, capital social, razão social, quadro de administrador ou inclusão de filial.',
        conditional: true,
        required: true,
        dependsOnAny: [
          'alteracaoEndereco',
          'quadroSocietario',
          'capitalSocial',
          'alteracaoRazaoSocial',
          'quadroAdministrador',
          'inclusaoFilial'
        ]
      }
    ]
  },

  paymentConfig: {
    amount: VALOR_BASE,
    quantityPricing: {
      triggerField: 'possuiAverbacao',
      triggerValue: 'SIM',
      quantityField: 'quantidadeAverbacoes',
      unitAmount: VALOR_POR_AVERBACAO
    }
  },

  protocoloConfig: {
    modeloRequerimento: '251',
    tiposAssunto: '268',
    tipoPedido: '9'
  },

  // Confirmado ao vivo — "Nome"/"CPFCNPJ" (251) são somenteLeitura (preenchidos
  // pela própria API a partir do cadastro do requerente) e não têm campo local
  // correspondente aqui (só nomeSociedade/cnpj), então ficam de fora.
  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'emailComercial', campoNome: 'EmailComercial' },
        { field: 'emailResidencial', campoNome: 'EmailResidencial' }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_SOCIEDADE
  ),

  tituloConfig: {
    tipoLancamentoId: 67,
    enderecoOrigem: 'sociedadeSimples'
  },

  steps: [
    {
      id: 'dados_sociedade',
      title: 'Dados da Sociedade',
      sections: [
        identificacaoSociedadeSection([
          { type: 'email', name: 'emailComercial', label: 'E-mail Comercial', required: true, placeholder: 'email@exemplo.com' },
          { type: 'email', name: 'emailResidencial', label: 'E-mail Residencial', required: false, placeholder: 'email@exemplo.com' }
        ]),
        {
          title: 'Averbação',
          fields: [
            {
              type: 'radio',
              name: 'possuiAverbacao',
              label: 'Esta Alteração Contratual terá averbação?',
              required: true,
              options: [
                { value: 'SIM', label: 'Sim' },
                { value: 'NAO', label: 'Não' }
              ],
              defaultValue: 'NAO'
            },
            {
              type: 'select',
              name: 'quantidadeAverbacoes',
              label: 'Quantidade de averbações',
              required: true,
              showWhen: { field: 'possuiAverbacao', value: 'SIM' },
              placeholder: 'Selecione a quantidade',
              options: [
                { value: '1', label: '1 averbação' },
                { value: '2', label: '2 averbações' },
                { value: '3', label: '3 averbações' },
                { value: '4', label: '4 averbações' },
                { value: '5', label: '5 averbações' }
              ]
            }
          ]
        },
        {
          title: 'Natureza da Alteração Contratual',
          fields: [
            { type: 'checkbox', name: 'alteracaoEndereco', label: 'Alteração de endereço' },
            { type: 'checkbox', name: 'quadroSocietario', label: 'Alteração do quadro societário' },
            { type: 'checkbox', name: 'capitalSocial', label: 'Alteração do capital social' },
            { type: 'checkbox', name: 'alteracaoRazaoSocial', label: 'Alteração da razão social' },
            { type: 'checkbox', name: 'quadroAdministrador', label: 'Alteração do quadro de administrador' },
            { type: 'checkbox', name: 'inclusaoFilial', label: 'Inclusão de filial' }
          ]
        }
      ]
    },
    enderecoSociedadeStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoAlteracaoContratualConfig;
